module.exports = __webpack_public_path__ + "static/media/audioAdjustment.7dd3ab1a.mp3";